import vars from '../helpers';

const init = () => {
	const $button = vars.$document.find('.js-menu-button');

	$button.on('click', () => {
		vars.$html.toggleClass('is-menu-open');
	});
};

const destroy = () => {
	vars.$html.removeClass('is-menu-open');
};

export default {
	init,
	destroy,
};
